/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * This table describes the Factors and related Products that will be ranged for a StockCreationTemplate.
 */
export interface StockCreationTemplateFactorInsert { 
    /**
     * A reference to the primary key in the StockCreationTemplates Table
     */
    stockCreationTemplateId: number;
    /**
     * The id of the container to use for creating a factor. A reference to the primary key in the Containers Table
     */
    containerId: number;
    /**
     * The divider of the factor. How many items are in the outer.
     */
    defaultDivider?: number;
    /**
     * The volume divider of the factor created
     */
    defaultVolumeDivider?: number;
    defaultPourTime?: number;
    /**
     * the promptForSerialNumber of the factor created.
     */
    defaultPromptForSerialNumber?: number;
    /**
     * If set to true, will automatically create a product when creating a stock item using this template.
     */
    autoCreateProduct?: boolean;
    /**
     * Specifies the productGroup of the product created if autoCreateProduct is set to true.
     */
    autoProductGroupId?: number;
    /**
     * The unique external key set by the current user accessing the API
     */
    externalKey?: string;
}